import CoreResize from '../../mixins/core-resize'

import AppModal from '../app-modal'
import AppYoutube from '../app-youtube'

export default
{
    name: 'app-modal-video',

    mixins:
    [
        CoreResize
    ],

    components:
    {
        AppModal,
        AppYoutube
    },

    props:
    {
        type: { type: String, default: '' },
        id: { type: String, default: '' },
        url: { type: String, default: '' }
    },

    data()
    {
        return {}
    },

    mounted()
    {
        this.initJWPlayer()

        window.addEventListener('keydown', this._onKeyDown)
    },

    destroyed()
    {
        window.removeEventListener('keydown', this._onKeyDown)
    },

    methods:
    {
        _onKeyDown(event)
        {
            if (event.keyCode === 27)
            {
                this.$root.closeModalVideo()
            }
        },

        _close()
        {
            this.$root.closeModalVideo()
        },

        initJWPlayer()
        {
            // No JW Player
            if (this.type !== 'jwplayer')
            {
                return
            }

            // Instanciate JW Player
            if (window.jwplayer)
            {
                window.setTimeout(() =>
                {
                    this.jwPlayer = window.jwplayer('modal-video-jwplayer').setup({
                        file: this.url,
                        mediaid: this.id,
                        autostart: true,
                        mute: false,
                        width: '100%',
                        height: '100%'
                    })
                }, 100)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-modal-video/script.js